import React from 'react';
import { Pressable, Text } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { radius, spacing, type, useAppTheme } from '@/theme';
import { ScaledSheet } from '@/theme/responsive';

interface Props {
  label: string;
  active?: boolean;
  onPress?: () => void;
  icon?: keyof typeof Ionicons.glyphMap;
}

export function FilterChip({ label, active, onPress, icon }: Props) {
  const { colors } = useAppTheme();

  return (
    <Pressable
      accessibilityRole="button"
      accessibilityState={{ selected: !!active }}
      onPress={onPress}
      style={({ pressed }) => [
        styles.chip,
        {
          backgroundColor: active ? colors.accent : colors.surface,
          borderColor: active ? colors.accent : colors.border,
        },
        pressed && styles.pressed,
      ]}>
      {icon && (
        <Ionicons
          name={icon}
          size={14}
          color={active ? colors.textOnAccent : colors.textSecondary}
        />
      )}
      <Text style={[type.bodyMedium, { color: active ? colors.textOnAccent : colors.textSecondary }]}>{label}</Text>
    </Pressable>
  );
}

const styles = ScaledSheet.create({
  chip: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.xs,
    paddingHorizontal: spacing.lg,
    paddingVertical: spacing.sm,
    borderRadius: radius.pill,
    borderWidth: 1,
  },
  pressed: { opacity: 0.8 },
});
